import { Badge, type Tone } from '@/components/ui/Badge'
import { formatInvoiceNumber, invoiceStanding, type InvoiceStanding } from '@/lib/invoicing'
import { today } from '@/lib/dates'
import type { Invoice } from './queries'

export const KIND_LABEL: Record<Invoice['kind'], string> = {
  booking: 'Booking',
  deposit: 'Deposit',
  balance: 'Balance',
  additional: 'Additional',
  standard: 'Invoice',
}

/** "Deposit invoice", "Booking invoice"; a plain one from New invoice is just "Invoice". */
export function invoiceTitle(kind: Invoice['kind']): string {
  return kind === 'standard' ? 'Invoice' : `${KIND_LABEL[kind]} invoice`
}

export const METHOD_LABEL: Record<'eft' | 'card' | 'cash' | 'other', string> = {
  eft: 'EFT',
  card: 'Card',
  cash: 'Cash',
  other: 'Other',
}

const STANDING: Record<InvoiceStanding, { label: string; tone: Tone }> = {
  draft: { label: 'Draft', tone: 'neutral' },
  open: { label: 'Awaiting payment', tone: 'amber' },
  overdue: { label: 'Overdue', tone: 'clay' },
  paid: { label: 'Paid', tone: 'sage' },
  void: { label: 'Void', tone: 'neutral' },
}

export function InvoiceStatusBadge({
  invoice,
}: {
  invoice: Pick<Invoice, 'status' | 'due_date' | 'amount_paid'> & { instalments?: Array<{ label: string; amount: number | string; due_date: string }> }
}) {
  const standing = invoiceStanding(invoice, today())
  const { label, tone } = STANDING[standing]
  return <Badge tone={tone}>{invoice.status === 'partially_paid' && standing !== 'overdue' ? 'Part paid' : label}</Badge>
}

/** "DLC0025": the number as printed, in her Studio Ninja format. */
export function invoiceNumber(n: number, prefix = 'DLC'): string {
  return formatInvoiceNumber(prefix, n)
}
